// extracted by mini-css-extract-plugin
export var chevronIcon = "_di-2";
export var teamName = "_di-1";
export var teamSwitcherButton = "_di-0";